import { apiRequestPath } from './requestApiPath';
import { apiRequestHeaders } from './requestHeaders';
import {API_METHOD} from "../../constants";

export const apiRequestOptions = (api, data = null, options = {}) => {
    const {
        withoutAuth = false,
        params,
        isBlob = false,
    } = options;

    return {
        method: api.method,
        url: apiRequestPath(api.path, params),
        ...(api.method === API_METHOD.GET ? {params: data} : {}),
        headers: apiRequestHeaders(!withoutAuth, api.method),
        ...(isBlob ? {responseType: 'blob'} : {}),
        json: true,
        data
    };
};
